export type Type = {
	searchTerm: string;
	showSuggested: boolean;
};

export function create(): Type {
	return {
		searchTerm: '',
		showSuggested: false,
	};
}

export function setSearchTerm(obj: Type, searchTerm: string): Type {
	return { ...obj, searchTerm: searchTerm };
}

export function setShowSuggested(obj: Type, showSuggested: boolean): Type {
	return { ...obj, showSuggested: showSuggested };
}

export function focus(obj: Type): Type {
	return { ...obj, showSuggested: true };
}

export function blur(obj: Type): Type {
	return { ...obj, showSuggested: false };
}
